import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Input, Button } from "reactstrap";
import filterFields from "./filterFields";
import styles from "./DynamicTableFilters.module.scss";

const DynamicTableFilters = ({ componentName, onApply = () => { }, onClear = () => { } }) => {
    const fields = filterFields[componentName] || [];
    const [filters, setFilters] = useState({});
    const [isFilterActive, setIsFilterActive] = useState(false);

    useEffect(() => {
        setIsFilterActive(Object.values(filters).some(value => value !== "" && value !== undefined));
    }, [filters]);

    const handleChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const clearFilters = () => {
        setFilters({});
        onClear();
    };

    const filterFieldsRender = () => {
        return (
            <>
                <Col>
                    <Row className={styles.filterFieldsRow}>
                        {fields.map((field, index) => {
                            if (field.type === "date") {
                                const inputRef = useRef(null);

                                const handleDateFieldClick = () => {
                                    if (inputRef.current) {
                                        inputRef.current.focus();
                                        setTimeout(() => {
                                            inputRef.current.showPicker?.();
                                        }, 100);
                                    }
                                };

                                return (
                                    <Col key={`${field.name}-${index}`} className="pe-2" xs={12} md={4} lg={3} xxl={2}>
                                        <div
                                            className={styles.dateInputWrapper}
                                            onClick={handleDateFieldClick}
                                        >
                                            <Input
                                                type="date"
                                                name={field.name}
                                                value={filters[field.name] || ""}
                                                onChange={handleChange}
                                                innerRef={inputRef}
                                                className={`${styles.filterInput} ${!filters[field.name] ? styles.datePlaceholder : ""}`}
                                            />
                                            {!filters[field.name] && <span className={styles.datePlaceholderText}>{field.placeholder}</span>}
                                        </div>
                                    </Col>
                                );
                            }
                            else if (field.type === "dropdown") {
                                return (
                                    <Col key={`${field.name}-${index}`} className="pe-2" xs={12} md={4} lg={3} xxl={2}>
                                        <Input
                                            type="select"
                                            name={field.name}
                                            value={filters[field.name] || ""}
                                            onChange={handleChange}
                                            className={`${styles.filterInput} ${!filters[field.name] ? styles.placeholderActive : ""}`}
                                        >
                                            <option value="" disabled>{field.placeholder}</option>
                                            {field.options.map((option, i) => (
                                                <option key={i} value={option}>{option}</option>
                                            ))}
                                        </Input>
                                    </Col>
                                );
                            }
                            else {
                                return (
                                    <Col key={`${field.name}-${index}`} className="pe-2" xs={12} md={4} lg={3} xxl={2}>
                                        <Input
                                            type={field.type}
                                            name={field.name}
                                            placeholder={field.placeholder}
                                            value={filters[field.name] || ""}
                                            onChange={handleChange}
                                            className={styles.filterInput}
                                        />
                                    </Col>
                                );
                            }
                        })}
                    </Row>
                </Col>
            </>
        )
    };

    return (
        <div className={styles.filterContainer}>
            {fields.length > 0 ? (
                <Row className={styles.filterRow}>
                    <Col xxl={1} className={styles.filterLabel}>Filter by:</Col>

                    {filterFieldsRender()}

                    <Col xxl={2} className={styles.buttonsColumn}>
                        <Button color="warning" onClick={() => onApply(filters)} className={styles.applyButton} disabled={!isFilterActive}>
                            Apply
                        </Button>
                        <Button color="link" onClick={clearFilters} className={styles.clearButton} disabled={!isFilterActive}>
                            Clear Filter
                        </Button>
                    </Col>
                </Row>
            ) : (
                <div className={styles.noFilters}>No filters available</div>
            )}
        </div>
    );
};

export default DynamicTableFilters;